import "./Contact.css";
import React from "react";
import { motion } from "framer-motion";
import { sendMail } from "../api/api";
import { useState } from "react";

const Contact = () => {
  const [error, setError] = useState({ name: "" });

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const full_message = `From Mr/Mrs ${name}. ${message}`;
  const receiver = "nkwetachaterence17@gmail.com";
  const subject = "Contact via Portfolio";

  const ValidateEmail = (email) => {
    var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return !!email && typeof email === "string" && email.match(emailRegex);
  };
  const formValidator = (name, email, message) => {
    if (name === "") {
      alert("Please enter your Name");
      setError({ name: "name" });
      return false;
    } else if (email === "" || !ValidateEmail(email)) {
      setError({ name: "email" });
      alert("Invalid email");
      return false;
    } else {
      if (message === "") {
        alert("Message is required");
        return false;
      } else if (message.length < 10) {
        alert("Message is too short");
        return false;
      } else return true;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formIsValid = formValidator(name, email, message);

    if (!formIsValid) return;
    console.log(receiver, subject, name, full_message);
    // await sendMail(receiver, subject, name, full_message).then((res) => {
    //   if (res.status === 202) {
    //     //Clear form
    //     setName("");
    //     setEmail("");
    //     setMessage("");
    //     alert("Message sent successfully");
    //   } else {
    //     alert("Message not sent");
    //   }
    // });
  };

  return (
    <div className=" mb-4 h-full   bg-secondary-background-color" id="contact">
      <div className="flex h-[10%] justify-center mb-6 ">
        <motion.h3 animate={{ rotate: 360 }} className="section title">
          CONTACT
        </motion.h3>
      </div>
      <div className="w-full h-[90%] flex items-start justify-center ">
        <h1>Coming Soon!</h1>{" "}
        {/* <form
          name="contact_form"
          onSubmit={handleSubmit}
          className="border-2 bg-white  border-gray-200 p-4 lg:w-1/3 lg:h-2/3"
        >
          <div className="inputs">
            <div
              className={`ui left action input ${
                error.name === "name" ? "error" : ""
              }`}
            >
              <label htmlFor="user-name">Name</label>
              <input
                type="text"
                id="user-name"
                value={name}
                onChange={(e) => {
                  setError({ name: "" });
                  setName(e.target.value);
                }}
              />
            </div>
            <div
              className={`ui left action input ${
                error.name === "email" ? "error" : ""
              }`}
            >
              <label htmlFor="user-email">Email</label>
              <input
                type="email"
                id="user-email"
                value={email}
                onChange={(e) => {
                  setError({ email: "" });
                  setEmail(e.target.value);
                }}
              />
            </div>
          </div>

          <textarea
            name="message"
            placeholder="Message here..."
            id="message"
            value={message}
            onChange={(e) => {
              setMessage(e.target.value);
              setError({ message: "" });
            }}
            className="border-2 border-gray-200 p-2 lg:min-h-[23em] focus:outline-none focus:ring-2 focus:ring-primary-color rounded-md focus:border-transparent"
          ></textarea>
          <div className="submit button">
            <button
              type="submit"
              onClick={handleSubmit}
              className="w-full text-xl rounded-md h-16 bold bg-primary-color text-white hover:bg-secondary-color hover:text-primary-color transition duration-300 ease-in-out"
            >
              Submit
            </button>
          </div>
        </form> */}
      </div>
    </div>
  );
};

export default Contact;
